import { LONG_WHITE_SPACE } from "Common/componentUtils/constants";
import ProgressOverlay from "Components/progressOverlay";
import React, { useEffect } from "react";
export default function VersionInfo(props) {
    useEffect(() => {
        props.getVersionInfo && props.getVersionInfo();
    }, []);
    return (React.createElement(ProgressOverlay, { show: props.inProgress },
        React.createElement("div", null, props.versionInfo || LONG_WHITE_SPACE)));
}
